'use client';

import Icon from '@/components/ui/AppIcon';

interface AuthBlockProps {
  authKey: string;
  authError: string;
  onKeyChange: (val: string) => void;
  onSubmit: () => void;
}

export default function AuthBlock({ authKey, authError, onKeyChange, onSubmit }: AuthBlockProps) {
  return (
    <div className="min-h-screen bg-[var(--color-background)] flex items-center justify-center px-4">
      <div className="bg-[var(--color-card)] border border-[var(--color-border)] rounded-lg p-8 max-w-sm w-full shadow-lg">
        <div className="flex items-center gap-2 mb-6">
          <Icon name="LockClosedIcon" size={24} variant="solid" className="text-[var(--color-primary)]" />
          <h1 className="text-lg font-bold text-[var(--color-foreground)]">Admin Access</h1>
        </div>
        <p className="text-sm text-[var(--color-muted-foreground)] mb-4">Enter the admin tool key to continue.</p>
        <input
          type="password"
          value={authKey}
          onChange={e => onKeyChange(e.target.value)}
          onKeyDown={e => e.key === 'Enter' && onSubmit()}
          placeholder="ADMIN_TOOL_KEY"
          className="w-full px-3 py-2 border border-[var(--color-border)] rounded text-sm bg-[var(--color-background)] text-[var(--color-foreground)] focus:outline-none focus:ring-2 focus:ring-[var(--color-ring)] mb-3"
        />
        {authError && (
          <p className="text-xs text-[var(--color-destructive)] mb-3 flex items-center gap-1">
            <Icon name="ExclamationCircleIcon" size={14} variant="solid" />
            {authError}
          </p>
        )}
        <button
          onClick={onSubmit}
          className="w-full py-2 bg-[var(--color-primary)] text-[var(--color-primary-foreground)] rounded text-sm font-medium hover:opacity-90 transition-opacity"
        >
          Authenticate
        </button>
        <p className="text-xs text-[var(--color-muted-foreground)] mt-3 text-center">Mock key: <code className="font-mono bg-[var(--color-muted)] px-1 rounded">ADMIN2026</code></p>
      </div>
    </div>
  );
}